(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-product-card"] && !Shopify.designMode) return;
  try {
    class CountdownTimer {
    constructor() {
      this.timers = new Map();
      this.init();
    }

    init() {
      this.initializeTimers();
    }

    initializeTimers() {
      const containers = document.querySelectorAll('.category-status-container');

      containers.forEach((container, index) => {
        const timer = container.querySelector('.timer-layout-minutes');

        if (timer) {
          this.startCountdown(container, `timer-${index}`, timer);
        }
      });
    }

    startCountdown(container, timerId, timer) {
      const timerPartOneSpan = timer?.querySelector('.timer-part-01 span');

      if (!this.isValidNumber(timerPartOneSpan.textContent)) {
        return;
      }

      let currentValue = this.parseNumber(timerPartOneSpan.textContent);

      const intervalId = setInterval(() => {
        currentValue--;

        timerPartOneSpan.textContent = this.formatDisplayValue(currentValue);

        if (currentValue <= 0) {
          this.handleTimerEnd(intervalId, timerId, container, timer);
        }
      }, 58000);

      this.timers.set(timerId, { intervalId, container, timerPartOneSpan });
    }

    handleTimerEnd(intervalId, timerId, container, timer) {
      const timerPartTwo = timer?.querySelector('.timer-part-02');
      const timerPartOneSpan = timer?.querySelector('.timer-part-01 span');

      clearInterval(intervalId);
      this.timers.delete(timerId);

      timerPartOneSpan.textContent = '00';
      timerPartOneSpan.classList.add('timer-ended');

      timerPartTwo.innerHTML = '<div class="counter-number"><span>00</span></div>';

      setTimeout(() => {
        container.innerHTML = '<div class="status-badge ended">Ended</div>';
      }, 500); // 0.5s delay
    }

    formatDisplayValue(value) {
      if (value < 10 && value >= 0) {
        return `0${value}`;
      }
      return value.toString();
    }

    parseNumber(text) {
      return parseInt(text.trim(), 10);
    }

    isValidNumber(text) {
      const num = this.parseNumber(text);
      return !isNaN(num) && num > 0;
    }

    destroy() {
      this.timers.forEach(({ intervalId }, timerId) => {
        clearInterval(intervalId);
        this.timers.delete(timerId);
      });
    }

    reinitialize() {
      this.destroy();
      this.initializeTimers();
    }
  }

  // Initialize timer when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    window.countdownTimer = new CountdownTimer();
  });

  // For Shopify theme editor compatibility
  if (typeof Shopify !== 'undefined') {
    document.addEventListener('shopify:section:load', () => {
      if (window.countdownTimer) {
        window.countdownTimer.reinitialize();
      }
    });

    document.addEventListener('shopify:section:unload', () => {
      if (window.countdownTimer) {
        window.countdownTimer.destroy();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
